import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

import { authMe } from "../services/api";

export default function RequireAdmin({ children }) {
  const [state, setState] = useState({
    loading: true,
    allowed: false,
  });

  useEffect(() => {
    let mounted = true;

    async function checkRole() {
      try {
        const user = await authMe();

        const allowed =
          user?.role === "admin" ||
          user?.role === "superadmin";

        if (mounted) {
          setState({
            loading: false,
            allowed,
          });
        }
      } catch {
        if (mounted) {
          setState({
            loading: false,
            allowed: false,
          });
        }
      }
    }

    checkRole();

    return () => {
      mounted = false;
    };
  }, []);

  if (state.loading) {
    return null;
  }

  if (!state.allowed) {
    return <Navigate to="/" replace />;
  }

  return children;
}